import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Label from './label';
import createMarkUp from '@medscape-promo/medscapetv/utils/create-markup';
class ComingSoonItem extends Component {
    constructor(props) {
        super(props);
        //console.log("[ComingSoonItem] props:",props);
    }
    render() {
        let { title, thumbnail, episode: episodeNumber, episodeTag } = this.props;
        const posterStyle = {
            backgroundImage: `url(${thumbnail})`
        }


        let episode = episodeTag.length > 0 ? episodeTag : `Episode ${episodeNumber}`
        return (
            <div className="playlist-item coming-soon" >
                <div className="content-container">
                    <div className="flex-content">
                        <div className="image-container" style={ posterStyle }>
                            
                        </div>
                        <Label comingsoon={true} />
                    </div>
                    <div className="meta-data">
                        <div className="episode">
                            <span dangerouslySetInnerHTML={ createMarkUp(episode) }></span>
                        </div>
                        <div className="title">
                            <span dangerouslySetInnerHTML={ createMarkUp(title)}></span>
                        </div>
                    </div>
                </div>
            </div>
        );

    }

    static get propTypes() {
        return {
            episodeTag: PropTypes.string,
            title: PropTypes.string,
            thumbnail: PropTypes.string,
            episode: PropTypes.string
        }
    }

    static get defaultProps() {
        return {
            episodeTag: "",
            title: "",
            thumbnail: "",
            episode: ""
        }
    }
}


export default ComingSoonItem